// extracted by mini-css-extract-plugin
module.exports = {"hero":"StatsHero--hero--2T4V0","action":"StatsHero--action--1duJ3","image":"StatsHero--image--Ex03K"};